import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Seo } from "../components/Seo";
import { PageHeader } from "../components/PageHeader";
import { Reveal } from "../components/Reveal";
import { TEAMS, IMAGES } from "../data/club";

export default function Teams() {
  return (
    <main data-testid="teams-page">
      <Seo
        title="Our Teams — Whitley Bay Cricket Club"
        description="Two Saturday league sides, a midweek XI, Sunday friendlies, juniors from U9 to U15, girls' cricket and a women's team launching in 2027."
      />
      <PageHeader
        eyebrow="Senior · Junior · Girls · Women"
        title="One club,"
        accent="every team."
        description="From the championship-winning First XI to All Stars on a summer evening — there is a team for everyone at Whitley Bay."
        image={IMAGES.batting}
        testId="teams-header"
      />
      <section className="max-w-7xl mx-auto px-5 sm:px-8 pb-24 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {TEAMS.map((t, i) => (
          <Reveal key={t.slug} delay={(i % 3) * 0.08}>
            <Link to={`/teams/${t.slug}`} data-testid={`teams-card-${t.slug}`}>
              <motion.div
                whileHover={{ y: -6 }}
                transition={{ type: "spring", stiffness: 260, damping: 22 }}
                className="group h-full rounded-2xl border border-white/10 bg-[#122030] overflow-hidden hover:border-[#E5AC3C]/40 transition-colors"
              >
                <div className="relative h-52 overflow-hidden">
                  <img src={t.image} alt={`${t.name} — Whitley Bay Cricket Club`} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" loading="lazy" />
                  {t.badge && (
                    <span className="absolute top-4 left-4 bg-[#E5AC3C] text-[#0B1520] text-[10px] font-bold uppercase tracking-[0.12em] px-3 py-1.5 rounded-full">
                      {t.badge}
                    </span>
                  )}
                </div>
                <div className="p-6">
                  <div className="flex items-center justify-between">
                    <h2 className="font-head text-xl font-bold">{t.name}</h2>
                    <ArrowRight size={17} className="text-[#5C7285] group-hover:text-[#E5AC3C] group-hover:translate-x-1 transition-all" />
                  </div>
                  <p className="mt-1 text-xs font-mono-club uppercase tracking-[0.15em] text-[#5C7285]">{t.league}</p>
                  <p className="mt-3 text-sm text-[#9BB0C1] leading-relaxed">{t.tagline}</p>
                </div>
              </motion.div>
            </Link>
          </Reveal>
        ))}
      </section>
    </main>
  );
}
